import {FC, memo, useCallback, useEffect, useState} from "react";
import {isEmpty} from "lodash";
import {SequencePollControl} from "../SequencePollControl";
import {IoIosNotifications} from "react-icons/io";
import {LuMessageCircle} from "react-icons/lu";
import {PiShareFat} from "react-icons/pi";
import {Pulsating} from "../Pulsating";
import {ShareCounterIconButton} from "../ShareCounterIconButton";
import {BiHeart, BiSolidHeart} from "react-icons/bi";
import {IS_STAGING} from "../../../utils/Constants";
import {FiMaximize, FiMinimize} from "react-icons/fi";
import {IoEyeOutline} from "react-icons/io5";
import { useStateValue } from "../../state-provider/StateProvider";
import {setGridAreaContent, setIsFullScreenExpanded} from "../../app/App.action";
import {EventInteractionType, ServerSettingsLiveDataCard, ws} from "../../../events/ws";
import {useShare} from "../../../hooks/useShare";
import useIsMobile from "../../../hooks/useIsMobile";


const SequencePollControlsComponent: FC<{
  liveStreamConnected: boolean,
  currentLiveStreamUrl: string | undefined,
  livestreamSeekTime: number,
}> = ({
  liveStreamConnected,
  currentLiveStreamUrl,
}) => {

  const [{
    shareBoostEnabled,
    liveStream,
    translations,
    isWidgetMaximized,
    shareUrl,
    liveChat,
    widgetLocation,
    liveData,
    cardUuid,
    statistics,
    liveStreamSubscribed,
    isFullScreenExpanded,
    header,
  }, dispatch] = useStateValue()

  const { handleShare, shareUrlLabel } = useShare({ shareUrl, widgetLocation })

  const [isLikeClicked, clickLike] = useState(false)
  const [cardVideoViews, setCardVideoViews] = useState("0")
  const [cardLikes, setCardLikes] = useState("0")

  useEffect(() => {

    let cardLiveData: ServerSettingsLiveDataCard | null  = null
    if (liveData?.cards && cardUuid) {
      cardLiveData = liveData.cards[cardUuid]
    }
    clickLike(cardLiveData?.liked === true)

    setCardLikes("" + (cardLiveData?.likes ?? statistics?.totalSocialLikes ?? 0))
    setCardVideoViews("" + (cardLiveData?.views ?? statistics?.totalViews ?? 0))

  }, [liveData, cardUuid, header])

  const handleLikeClick = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    ws.sendEvent(EventInteractionType.SOCIAL_LIKE)
    if (!isLikeClicked) {
      setCardLikes("" + (parseInt(cardLikes) + 1))
    }

    clickLike(true)
  }

  const isMobile = useIsMobile()

  const toggleHeaderFullscreen = useCallback(() => {

    let newMode = !isFullScreenExpanded

    dispatch(setIsFullScreenExpanded(newMode))
  }, [isFullScreenExpanded])

  const clickShowReminderForm = useCallback(() => dispatch(setGridAreaContent('LiveStreamReminderForm')), [dispatch])

  const showChat = useCallback(() => {
    dispatch(setGridAreaContent('LiveChat'))
  }, [dispatch])

  return (
    <>
      { isWidgetMaximized && (
        <div className="sequence-poll-controls">

          {!isEmpty(liveStream) && <SequencePollControl
              icon={<IoIosNotifications />}
              label={liveStreamSubscribed ? translations['SubscriptionIconSubscribedLabel'] : translations['SubscriptionIconNonSubscribedLabel']}
              onClick={clickShowReminderForm}
          />}
          {liveChat && <SequencePollControl
              icon={<LuMessageCircle />}
              label={""}
              onClick={showChat}
          />}
          {(navigator.clipboard) && <SequencePollControl
              icon={<PiShareFat />}
              label={shareUrlLabel}
              label2={shareBoostEnabled ? <Pulsating><ShareCounterIconButton /></Pulsating> : undefined}
              onClick={handleShare}
          />}

          <SequencePollControl
            animationClass={"like-heart-animation"}
            icon={isLikeClicked ? <BiSolidHeart /> : <BiHeart />}
            label={cardLikes + ""}
            onClick={handleLikeClick} />
          {!isMobile && IS_STAGING && <SequencePollControl
              icon={isFullScreenExpanded ? <FiMaximize /> : <FiMinimize />}
              label={""}
              onClick={toggleHeaderFullscreen}
          />}
          <SequencePollControl
            icon={<IoEyeOutline />}
            label={"" + ((currentLiveStreamUrl && liveStreamConnected) ? liveData?.liveStreamViewers : cardVideoViews)}
          />
        </div>
      )}
    </>
  )
}

export const SequencePollControls = memo(SequencePollControlsComponent)